export const webRoutes = {
  priceConfiguration: {
    new: () => `/price-configuration/new`,
    id: (id?: string) => id ? `/price-configuration/${id}` : `/price-configuration/:priceConfigId`,
  },
  plans: {
    upgrade: () => `/plans/upgrade`
  }
}
